<template>
  <b-card class="company-card shadow-sm">
    <div class="company-content">
      <div class="company-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
          <path d="M6 12H4a2 2 0 0 0-2 2v8h4" />
          <path d="M18 9h2a2 2 0 0 1 2 2v11" />
          <path d="M10 6h4" />
          <path d="M10 10h4" />
          <path d="M10 14h4" />
          <path d="M10 18h4" />
        </svg>
      </div>

      <div class="company-info">
        <h4 class="company-name">{{ company.name }}</h4>

        <div class="company-details">
          <div class="detail-item">
            <span class="label">CNPJ:</span>
            <span class="value">{{ company.document | tax_id }}</span>
          </div>

          <div v-if="company.source" class="detail-item">
            <span class="label">Fonte:</span>
            <span class="value">{{ company.source }}</span>
          </div>

          <div v-if="company.socialCapital" class="detail-item">
            <span class="label">Capital Social:</span>
            <span class="value">{{ company.socialCapital | value }}</span>
          </div>

          <div v-if="company.creditLimit" class="detail-item">
            <span class="label">Limite de Crédito:</span>
            <span class="value">{{ company.creditLimit | value }}</span>
          </div>
        </div>
      </div>


      <div
        v-if="company.salesforceRegistered !== undefined"
        :class="['salesforce-status', company.salesforceRegistered ? 'is-registered' : 'not-registered']"
      >
        <feather-icon icon="CloudIcon" size="16" />
        <span>
          {{ company.salesforceRegistered ? 'Cadastrado no Salesforce' : 'Não cadastrado no Salesforce' }}
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'CompanyResult',

  components: { BCard },

  props: {
    company: {
      type: Object,
      required: true
    }
  },

}
</script>

<style scoped>
.company-card {
  border-radius: 10px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.company-card:hover {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
}

.company-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 4px;
}

.company-icon {
  width: 60px;
  height: 60px;
  background-color: transparent;
  border-radius: 12px;
  border: 1px solid #b5b4b8c9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e5873;
  flex-shrink: 0;
}

.company-info {
  flex: 1;
  min-width: 0;
}

.company-name {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-details {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.detail-item {
  display: flex;
  gap: 6px;
  font-size: 13px;
}

.detail-item .label {
  color: #6e6b7b;
  font-weight: 500;
}

.detail-item .value {

  font-weight: 600;
}

.salesforce-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.salesforce-status.is-registered {
  background-color: #e8f8f5;
  color: #198754;
}

.salesforce-status.is-registered svg {
  color: #198754;
}

.salesforce-status.not-registered {
  background-color: #f8d7da;
  color: #842029;
}

.salesforce-status.not-registered svg {
  color: #842029;
}

@media (max-width: 768px) {
  .company-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .company-icon {
    width: 48px;
    height: 48px;
  }

  .company-details {
    flex-direction: column;
    gap: 4px;
  }

  .salesforce-status {
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }
}
</style>